import { AuthHttp } from 'angular2-jwt';
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { Http } from '@angular/http';


@Injectable()
export class AgendaService {

  constructor(private http: Http, private authHttp: AuthHttp) { }

  getEntireAgenda() {
    return this.http.get("/api/agenda").map(res => res.json());
  }

  create(agenda: any) {
    return this.authHttp.post('/api/agenda/', agenda).map(res => res.json());
  }

  delete(id: number) {
    return this.authHttp.delete('/api/agenda/' + id).map(res => res.json())
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/Services/agenda.service.ts